import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ShortageCommentsService } from './shortage-comments.service';
import { AppConstants } from '../../../app.constants';

@Component({
  selector: 'app-shortage-comments',
  templateUrl: './shortage-comments.component.html',
  styleUrl: './shortage-comments.component.scss'
})
export class ShortageCommentsComponent implements OnInit, OnChanges {
  @Input() allData: any[] = [];

  groups: any[] = [
    { name: 'Critical Stock', items: [], color: '#E74C3C' },
    { name: 'Potential Discontinuations', items: [], color: '#F1C40F' },
    { name: 'Oncology High Priority', items: [], color: '#3498DB' },
  ];
  priorityGroups: any[] = [];
  selectedGroup: any = null;

  constructor(private commentsService: ShortageCommentsService) {}

  ngOnInit(): void {
    this.initGroups();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allData'] && !changes['allData'].firstChange) {
      this.initGroups();
    }
  }

  initGroups(): void {
    this.groups.forEach((g, idx) => {
      g.items = this.allData.slice(idx * 2, idx * 2 + 2).map(d => ({
        name: d.brand_name && d.brand_name !== 'N/A' ? d.brand_name : d.ndc,
        ndc: d.ndc
      }));
    });
    if (!this.selectedGroup && this.groups.length > 0) {
      this.selectedGroup = this.groups[0];
    }
  }

  selectGroup(group: any): void {
    this.selectedGroup = group;
  }

  removeFromGroup(group: any, item: any): void {
    group.items = group.items.filter((it: any) => it.ndc !== item.ndc);
  }
}
